import { useMemo, FC, PropsWithChildren, useContext } from "react";

import type { User } from "@dndbeyond/auth/dist/types/user";
import { RollType } from "@dndbeyond/dice";
import { WithDiceRollv2 } from "@dndbeyond/dice-components";
import { RollableComponentProps } from "@dndbeyond/dice-components/dist/types/src/components/WithDiceRollv2";
import { Context as DiceWorkerContext } from "@dndbeyond/pocket-dimension-dice/context";

import { useAuth } from "~/contexts/Authentication";
import { useFeatureFlags } from "~/contexts/FeatureFlag";

export interface DigitalDiceWrapperProps
  extends Omit<
      RollableComponentProps,
      "BaseComponent" | "useCustomizableDiceNotation"
    >,
    PropsWithChildren {}

export const DigitalDiceWrapper: FC<DigitalDiceWrapperProps> = ({
  useAdvancedMenu = true,
  rollType,
  children,
  ...props
}) => {
  const useCustomizableDiceNotation = useMemo(
    () => rollType === RollType.Damage || rollType === RollType.Heal,
    [rollType]
  );
  const user = useAuth();
  const { tacticalMapsShared3dDiceFlag } = useFeatureFlags();
  const { env, hasPddErrored, isPddReady } = useContext(DiceWorkerContext);

  return (
    <WithDiceRollv2
      BaseComponent={<>{children}</>}
      useAdvancedMenu={useAdvancedMenu}
      useCustomizableDiceNotation={useCustomizableDiceNotation}
      rollType={rollType}
      {...props}
      userId={Number(user?.id)}
      showDiceNotification={!tacticalMapsShared3dDiceFlag}
      canUseShared3dDice={tacticalMapsShared3dDiceFlag}
      user={user as unknown as User}
      env={env}
      hasWorkerErrored={hasPddErrored}
      isWorkerReady={isPddReady}
    />
  );
};
